export default {

    signature: 'qv-cloak',

    handle(node) {

        if (node.nodeType !== Node.ELEMENT_NODE) {
            return null
        }

        if (node.getAttribute(this.signature)) {
            return
        }

        node.removeAttribute(this.signature)

        return null

    },

}
